import { render } from "./ProfileRandom.vue?vue&type=template&id=e4d54c08&scoped=true"
import script from "./ProfileRandom.vue?vue&type=script&lang=js"
export * from "./ProfileRandom.vue?vue&type=script&lang=js"

import "./ProfileRandom.vue?vue&type=style&index=0&id=e4d54c08&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d54c08"]])

export default __exports__